export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'Hailuo AI视频生成器 - 创新AI视频创作平台',
        pageDescription: '体验Hailuo AI视频生成器，专注于智能视频创作和内容优化。采用先进深度学习技术，生成高质量、富有创意的视频内容。在WeryAI平台免费试用。',
        pageKeywords: 'Hailuo AI, AI视频生成器, AI视频创作, 人工智能视频, 视频生成工具, 免费AI视频, WeryAI, 视频制作',

        // 生成器部分
        generatorTitle: 'Hailuo 02 AI 视频生成器（MiniMax）',
        generatorDescription: 'WeryAI 现已深度集成Hailuo AI模型，Hailuo AI，一款创新的 AI 视频生成器。它由<span class="highlight-bold">中国科技公司MiniMax 开发</span>，让用户能够根据<span class="highlight-bold">文本和图像创建视频片段</span>。Hailuo 还提供<span class="highlight-bold">逼真的 AI 配音和智能音乐库</span>，可与您的视觉内容完美同步。立即<span class="highlight-bold">免费试用 Hailuo AI</span>！',
        
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Hailuo AI 的主要功能',
        coreFeaturesSubtitle: '探索 Hailuo AI 视频生成器的核心功能，开启革命性的 AI 视频创作之旅',

        // 准确遵循指令
        accurateInstructionFollowingTitle: '准确遵循指令',
        accurateInstructionFollowingDescription: '以无与伦比的准确度理解并执行您的创意提示，确保生成的视频完全符合您的创作意图。',

        // 极端物理和动态运动
        extremePhysicsMotionTitle: '极端物理和动态运动',
        extremePhysicsMotionDescription: '即使是最苛刻的场景也能提供无缝、逼真的动作，展现出色的物理模拟和运动效果。',

        // 清晰的原生 1080p 输出
        native1080pOutputTitle: '清晰的原生 1080p 输出',
        native1080pOutputDescription: '体验原生 1080p 分辨率的专业级视觉效果，每一帧都呈现出令人惊叹的清晰度和细节。',

        // 无与伦比的成本效益
        costEffectiveTitle: '无与伦比的成本效益',
        costEffectiveDescription: '无需花费太多即可获得世界一流的视频质量，为您提供性价比最高的 AI 视频生成解决方案。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择Hailuo AI模型',
        step1Description: '前往<span class="highlight-text">"AI视频生成"</span>页面，然后在模型下拉菜单中点击"Hailuo AI"。',
        step2Title: '输入您的创意内容',
        step2Description: '描述您想要生成的内容，或上传图片进行转换，并选择您喜欢的风格和效果。',
        step3Title: '下载您的视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的优化视频。',

        // YouTube 视频部分
        youtubeTitle: '关于 Hailuo 02 视频模型的 YouTube 视频',
        youtubeVideosTitle: '关于 Hailuo 02 视频模型的 YouTube 视频',
        youtubeVideoTitle: '关于 Hailuo 02 视频模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Hailuo 02 视频模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        sora2Title: 'OpenAI Sora-2 AI 视频生成器',
        veo31Title: 'Google Veo 3.1 AI 视频生成器',
        veo3Title: 'Google Veo 3 AI 视频生成器',
        veo3FastTitle: 'Google Veo 3 Fast AI 视频生成器',
        klingTitle: 'Kling AI 视频生成器',
        runwayTitle: 'Runway AI 视频生成器',
        wanTitle: 'Wan AI 视频生成器',
        hailuo23Title: 'Hailuo 2.3 AI视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaSubtitle: '立即体验 Hailuo AI，将您的创意转化为精彩视频',
        ctaDescription: '立即体验 Hailuo AI，将您的创意转化为精彩视频',
        ctaButton: '在 WeryAI 上试用 Hailuo AI',

        ctaNote: '无需信用卡',
        ctaDisclaimer: '无需信用卡',


        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoUnsupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    en: {
        // Page title and description
        pageTitle: 'Hailuo AI Video Generator - Innovative AI Video Creation Platform',
        pageDescription: 'Experience Hailuo AI video generator focused on intelligent video creation and content optimization. Uses advanced deep learning technology to generate high-quality and creative video content. Try it free on WeryAI platform.',
        pageKeywords: 'Hailuo AI, AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Hailuo 02 AI Video Generator (MiniMax)',
        generatorDescription: 'WeryAI now deeply integrates the Hailuo AI model, Hailuo AI, an innovative AI video generator. It\'s developed by <span class="highlight-bold">MiniMax, a Chinese tech company</span>, enabling users to <span class="highlight-bold">create video clips from text and images</span>. Hailuo also provides <span class="highlight-bold">realistic AI voice-overs and intelligent music library</span> that perfectly sync with your visual content. <span class="highlight-bold">Try Hailuo AI for free</span> now!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo AI Main Features',
        coreFeaturesSubtitle: 'Explore the core features of Hailuo AI video generator and embark on a revolutionary AI video creation journey',

        // Accurate instruction following
        accurateInstructionFollowingTitle: 'Accurate Instruction Following',
        accurateInstructionFollowingDescription: 'Understand and execute your creative prompts with unparalleled accuracy, ensuring the generated videos fully match your creative intent.',

        // Extreme physics and dynamic motion
        extremePhysicsMotionTitle: 'Extreme Physics and Dynamic Motion',
        extremePhysicsMotionDescription: 'Provides seamless and realistic motion even in the most demanding scenarios, showcasing excellent physics simulation and motion effects.',

        // Native 1080p output
        native1080pOutputTitle: 'Crystal Clear Native 1080p Output',
        native1080pOutputDescription: 'Experience professional-grade visual effects at native 1080p resolution, with every frame showcasing stunning clarity and detail.',

        // Cost-effective
        costEffectiveTitle: 'Unparalleled Cost-Effectiveness',
        costEffectiveDescription: 'Get world-class video quality without spending too much, providing you with the most cost-effective AI video generation solution.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Hailuo AI Model',
        step1Description: 'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo AI" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description: 'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description: 'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideosTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideoTitle: 'YouTube Videos About Hailuo 02 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 02 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',
        hailuo23Title: 'Hailuo 2.3 AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaDescription: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo AI on WeryAI',
        ctaNote: 'No credit card required',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
    ja: {
        // ページタイトルと説明
        pageTitle: 'Hailuo AI動画ジェネレーター - 革新的AI動画作成プラットフォーム',
        pageDescription: 'Hailuo AI動画ジェネレーターを体験。インテリジェント動画作成とコンテンツ最適化に特化。先進的な深層学習技術を使用し、高品質で創造的な動画コンテンツを生成。WeryAIプラットフォームで無料試用。',
        pageKeywords: 'Hailuo AI, AI動画ジェネレーター, AI動画作成, 人工知能動画, 動画生成ツール, 無料AI動画, WeryAI, 動画制作',

        // ジェネレーター部分
        generatorTitle: 'Hailuo AI動画ジェネレーター',
        generatorDescription: 'WeryAI はHailuo AIモデルを深く統合し、Hailuo AIは、インテリジェント動画作成とコンテンツ最適化に特化した革新的なAI動画生成プラットフォームです。先進的な深層学習技術を使用し、高品質で創造的な動画コンテンツを生成できます。WeryAI動画ジェネレーターでHailuo AIを無料でお試しください！',
        
        // タブ
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // コア機能部分
        coreFeaturesTitle: 'Hailuo AI の主要機能',
        coreFeaturesSubtitle: 'Hailuo AI動画ジェネレーターのコア機能を探索し、革命的なAI動画作成の旅を始めましょう',

        // 正確な指示遵守
        accurateInstructionFollowingTitle: '正確な指示遵守',
        accurateInstructionFollowingDescription: '比類のない正確さで創造的なプロンプトを理解し実行し、生成された動画が創造的な意図を完全に満たすことを保証します。',

        // 極端な物理と動的モーション
        extremePhysicsMotionTitle: '極端な物理と動的モーション',
        extremePhysicsMotionDescription: '最も厳しいシナリオでもシームレスでリアルな動きを提供し、優れた物理シミュレーションと動き効果を示します。',

        // ネイティブ1080p出力
        native1080pOutputTitle: 'クリアなネイティブ1080p出力',
        native1080pOutputDescription: 'ネイティブ1080p解像度でプロフェッショナルグレードの視覚効果を体験し、すべてのフレームが驚くべき明瞭さと細部を表示します。',

        // コスト効果
        costEffectiveTitle: '比類のないコスト効果',
        costEffectiveDescription: 'あまり費用をかけずに世界クラスの動画品質を獲得し、最もコスト効果の高いAI動画生成ソリューションを提供します。',

        // インテリジェント動画作成機能
        intelligentCreationTitle: 'インテリジェント動画作成',
        intelligentCreationDescription: '先進的なAI技術に基づき、複雑な創造的ニーズを理解し、要件に合致する動画コンテンツを自動生成し、創作プロセスをよりインテリジェントで効率的にします。',

        // コンテンツ最適化機能
        contentOptimizationTitle: 'コンテンツ最適化',
        contentOptimizationDescription: 'インテリジェントなコンテンツ最適化機能を提供し、動画パラメータを自動調整して、生成されたコンテンツが最適な品質効果を達成することを保証します。',

        // 創造的表現機能
        creativeExpressionTitle: '創造的表現',
        creativeExpressionDescription: '複数の創造的表現方法をサポートし、あなたのアイデアが最も適切な形で表現され、ユニークな視覚体験を作り出します。',

        // 高品質出力機能
        highQualityOutputTitle: '高品質出力',
        highQualityOutputDescription: '先進的なアルゴリズム技術を使用し、生成された動画コンテンツがプロフェッショナルグレードの品質基準を満たし、様々な創造的ニーズを満たすことを保証します。',

        // 使用方法部分
        howToUseTitle: '使用方法',
        howToUseSubtitle: '簡単3ステップで開始',
        step1Title: 'Hailuo AIモデル選択',
        step1Description: '<span class="highlight-text">「AI動画生成」</span>ページに移動し、モデルドロップダウンメニューで「Hailuo AI」をクリックします。',
        step2Title: '創造的なコンテンツを入力',
        step2Description: '生成したい内容を記述するか、変換用の画像をアップロードし、好きなスタイルと効果を選択します。',
        step3Title: '動画をダウンロード',
        step3Description: '「作成」をクリックして、生成された最適化された動画を自由にダウンロードまたは共有します。',

        // YouTube動画部分
        youtubeTitle: 'Hailuo AI動画ジェネレーターに関するYouTube動画',
        youtubeVideosTitle: 'Hailuo AI動画ジェネレーターに関するYouTube動画',
        youtubeVideoTitle: 'Hailuo AI動画ジェネレーターに関するYouTube動画',

        // X投稿部分
        xPostsTitle: 'Hailuo AI動画ジェネレーターに関するX投稿',

        // 他のモデル探索部分
        exploreModelsTitle: '他の動画モデルを探索',
        sora2Title: 'OpenAI Sora-2 AI動画ジェネレーター',
        veo31Title: 'Google Veo 3.1 AI動画ジェネレーター',
        veo3Title: 'Google Veo 3 AI動画ジェネレーター',
        veo3FastTitle: 'Google Veo 3 Fast AI動画ジェネレーター',
        klingTitle: 'Kling AI動画ジェネレーター',
        runwayTitle: 'Runway AI動画ジェネレーター',
        wanTitle: 'Wan AI動画ジェネレーター',
        hailuo23Title: 'Hailuo 2.3 AI動画ジェネレーター',

        // FAQ部分
        faqTitle: 'よくある質問',

        // CTA部分
        ctaTitle: '作成を始める準備はできましたか？',
        ctaSubtitle: '今すぐHailuo AIを体験し、あなたの創造性を素晴らしい動画に変換',
        ctaDescription: '今すぐHailuo AIを体験し、あなたの創造性を素晴らしい動画に変換',
        ctaButton: 'WeryAIでHailuo AIを試す',
        ctaNote: 'クレジットカード不要',
        ctaDisclaimer: 'クレジットカード不要',

        // 動画再生関連
        videoNotSupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoUnsupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoLoadingError: '動画の読み込みに失敗しました',
        videoLoadError: '動画の読み込みに失敗しました',
        videoReload: '再読み込み',
    },
    ko: {
        // 페이지 제목과 설명
        pageTitle: 'Hailuo AI 비디오 생성기 - 혁신적인 AI 비디오 제작 플랫폼',
        pageDescription: 'Hailuo AI 비디오 생성기를 체험하세요. 지능형 비디오 제작과 콘텐츠 최적화에 특화. 고급 딥러닝 기술을 사용하여 고품질이고 창의적인 비디오 콘텐츠를 생성합니다. WeryAI 플랫폼에서 무료로 체험하세요.',
        pageKeywords: 'Hailuo AI, AI 비디오 생성기, AI 비디오 제작, 인공지능 비디오, 비디오 생성 도구, 무료 AI 비디오, WeryAI, 비디오 제작',

        // 생성기 부분
        generatorTitle: 'Hailuo AI 비디오 생성기',
        generatorDescription: 'WeryAI는 이제 Hailuo AI 모델을 심층 통합하여, Hailuo AI는 지능형 비디오 제작과 콘텐츠 최적화에 특화된 혁신적인 AI 비디오 생성 플랫폼입니다. 고급 딥러닝 기술을 사용하여 고품질이고 창의적인 비디오 콘텐츠를 생성할 수 있습니다. WeryAI 비디오 생성기에서 Hailuo AI를 무료로 체험해보세요!',
        
        // 탭
        tabImageToVideo: '이미지에서 비디오',
        tabTextToVideo: '텍스트에서 비디오',

        // 핵심 기능 부분
        coreFeaturesTitle: 'Hailuo AI 주요 기능',
        coreFeaturesSubtitle: 'Hailuo AI 비디오 생성기의 핵심 기능을 탐색하고 혁신적인 AI 비디오 제작 여정을 시작하세요',

        // 정확한 지시 따르기
        accurateInstructionFollowingTitle: '정확한 지시 따르기',
        accurateInstructionFollowingDescription: '비할 데 없는 정확도로 창의적인 프롬프트를 이해하고 실행하여 생성된 비디오가 창의적 의도를 완전히 충족하도록 보장합니다.',

        // 극단적인 물리 및 동적 움직임
        extremePhysicsMotionTitle: '극단적인 물리 및 동적 움직임',
        extremePhysicsMotionDescription: '가장 까다로운 시나리오에서도 원활하고 현실적인 움직임을 제공하여 우수한 물리 시뮬레이션 및 움직임 효과를 보여줍니다.',

        // 네이티브 1080p 출력
        native1080pOutputTitle: '선명한 네이티브 1080p 출력',
        native1080pOutputDescription: '네이티브 1080p 해상도로 전문가급 시각 효과를 경험하며 모든 프레임이 놀라운 선명도와 세부사항을 표시합니다.',

        // 비용 효율성
        costEffectiveTitle: '비할 데 없는 비용 효율성',
        costEffectiveDescription: '너무 많이 지출하지 않고도 세계 수준의 비디오 품질을 얻을 수 있으며 가장 비용 효율적인 AI 비디오 생성 솔루션을 제공합니다.',

        // 지능형 비디오 제작 기능
        intelligentCreationTitle: '지능형 비디오 제작',
        intelligentCreationDescription: '고급 AI 기술을 기반으로 복잡한 창의적 요구사항을 이해하고 요구사항에 맞는 비디오 콘텐츠를 자동으로 생성하여 창작 과정을 더욱 지능적이고 효율적으로 만듭니다.',

        // 콘텐츠 최적화 기능
        contentOptimizationTitle: '콘텐츠 최적화',
        contentOptimizationDescription: '지능형 콘텐츠 최적화 기능을 제공하여 비디오 매개변수를 자동으로 조정하고 생성된 콘텐츠가 최적의 품질 효과를 달성하도록 보장합니다.',

        // 창의적 표현 기능
        creativeExpressionTitle: '창의적 표현',
        creativeExpressionDescription: '여러 창의적 표현 방법을 지원하여 당신의 아이디어가 가장 적절한 형태로 표현되도록 하고 독특한 시각적 경험을 만들어냅니다.',

        // 고품질 출력 기능
        highQualityOutputTitle: '고품질 출력',
        highQualityOutputDescription: '고급 알고리즘 기술을 사용하여 생성된 비디오 콘텐츠가 전문가급 품질 기준을 충족하고 다양한 창의적 요구사항을 만족하도록 보장합니다.',

        // 사용 방법 부분
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 3단계로 시작',
        step1Title: 'Hailuo AI 모델 선택',
        step1Description: '<span class="highlight-text">「AI 비디오 생성」</span> 페이지로 이동한 다음 모델 드롭다운 메뉴에서 「Hailuo AI」를 클릭합니다.',
        step2Title: '창의적인 콘텐츠 입력',
        step2Description: '생성하려는 내용을 설명하거나 변환용 이미지를 업로드하고 선호하는 스타일과 효과를 선택합니다.',
        step3Title: '비디오 다운로드',
        step3Description: '「생성」을 클릭하여 생성된 최적화된 비디오를 자유롭게 다운로드하거나 공유합니다.',

        // YouTube 비디오 부분
        youtubeTitle: 'Hailuo AI 비디오 생성기에 대한 YouTube 비디오',
        youtubeVideosTitle: 'Hailuo AI 비디오 생성기에 대한 YouTube 비디오',
        youtubeVideoTitle: 'Hailuo AI 비디오 생성기에 대한 YouTube 비디오',

        // X 게시물 부분
        xPostsTitle: 'Hailuo AI 비디오 생성기에 대한 X 게시물',

        // 다른 모델 탐색 부분
        exploreModelsTitle: '다른 비디오 모델 탐색',
        sora2Title: 'OpenAI Sora-2 AI 비디오 생성기',
        veo31Title: 'Google Veo 3.1 AI 비디오 생성기',
        veo3Title: 'Google Veo 3 AI 비디오 생성기',
        veo3FastTitle: 'Google Veo 3 Fast AI 비디오 생성기',
        klingTitle: 'Kling AI 비디오 생성기',
        runwayTitle: 'Runway AI 비디오 생성기',
        wanTitle: 'Wan AI 비디오 생성기',
        hailuo23Title: 'Hailuo 2.3 AI 비디오 생성기',

        // FAQ 부분
        faqTitle: '자주 묻는 질문',

        // CTA 부분
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaSubtitle: '지금 Hailuo AI를 체험하고 당신의 창의성을 놀라운 비디오로 변환하세요',
        ctaDescription: '지금 Hailuo AI를 체험하고 당신의 창의성을 놀라운 비디오로 변환하세요',
        ctaButton: 'WeryAI에서 Hailuo AI 체험하기',
        ctaNote: '신용카드 불필요',
        ctaDisclaimer: '신용카드 불필요',

        // 비디오 재생 관련
        videoNotSupported: '귀하의 브라우저는 비디오 재생을 지원하지 않습니다',
        videoUnsupported: '귀하의 브라우저는 비디오 재생을 지원하지 않습니다',
        videoLoadingError: '비디오 로딩 실패',
        videoLoadError: '비디오 로딩 실패',
        videoReload: '다시 로드',
    },
    tw: {

        // 页面标题和描述
        pageTitle: 'Hailuo AI视频生成器 - 创新AI视频创作平台',
        pageDescription: '体验Hailuo AI视频生成器，专注于智能视频创作和内容优化。采用先进深度学习技术，生成高质量、富有创意的视频内容。在WeryAI平台免费试用。',
        pageKeywords: 'Hailuo AI, AI视频生成器, AI视频创作, 人工智能视频, 视频生成工具, 免费AI视频, WeryAI, 视频制作',

        // 生成器部分
        generatorTitle: 'Hailuo 02 AI 视频生成器（MiniMax）',
        generatorDescription: 'WeryAI 現已深度整合Hailuo AI模型，Hailuo AI，一款创新的 AI 视频生成器。它由<span class="highlight-bold">中国科技公司MiniMax 开发</span>，让用户能够根据<span class="highlight-bold">文本和图像创建视频片段</span>。Hailuo 还提供<span class="highlight-bold">逼真的 AI 配音和智能音乐库</span>，可与您的视觉内容完美同步。立即<span class="highlight-bold">免费试用 Hailuo AI</span>！',
        
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Hailuo AI 的主要功能',
        coreFeaturesSubtitle: '探索 Hailuo AI 视频生成器的核心功能，开启革命性的 AI 视频创作之旅',

        // 准确遵循指令
        accurateInstructionFollowingTitle: '准确遵循指令',
        accurateInstructionFollowingDescription: '以无与伦比的准确度理解并执行您的创意提示，确保生成的视频完全符合您的创作意图。',

        // 极端物理和动态运动
        extremePhysicsMotionTitle: '极端物理和动态运动',
        extremePhysicsMotionDescription: '即使是最苛刻的场景也能提供无缝、逼真的动作，展现出色的物理模拟和运动效果。',

        // 清晰的原生 1080p 输出
        native1080pOutputTitle: '清晰的原生 1080p 输出',
        native1080pOutputDescription: '体验原生 1080p 分辨率的专业级视觉效果，每一帧都呈现出令人惊叹的清晰度和细节。',

        // 无与伦比的成本效益
        costEffectiveTitle: '无与伦比的成本效益',
        costEffectiveDescription: '无需花费太多即可获得世界一流的视频质量，为您提供性价比最高的 AI 视频生成解决方案。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择Hailuo AI模型',
        step1Description: '前往<span class="highlight-text">"AI视频生成"</span>页面，然后在模型下拉菜单中点击"Hailuo AI"。',
        step2Title: '输入您的创意内容',
        step2Description: '描述您想要生成的内容，或上传图片进行转换，并选择您喜欢的风格和效果。',
        step3Title: '下载您的视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的优化视频。',

        // YouTube 视频部分
        youtubeTitle: '关于 Hailuo 02 视频模型的 YouTube 视频',
        youtubeVideosTitle: '关于 Hailuo 02 视频模型的 YouTube 视频',
        youtubeVideoTitle: '关于 Hailuo 02 视频模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Hailuo 02 视频模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        sora2Title: 'OpenAI Sora-2 AI 影片生成器',
        veo31Title: 'Google Veo 3.1 AI 影片生成器',
        veo3Title: 'Google Veo 3 AI 影片生成器',
        veo3FastTitle: 'Google Veo 3 Fast AI 影片生成器',
        klingTitle: 'Kling AI 影片生成器',
        runwayTitle: 'Runway AI 影片生成器',
        wanTitle: 'Wan AI 影片生成器',
        hailuo23Title: 'Hailuo 2.3 AI视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaSubtitle: '立即体验 Hailuo AI，将您的创意转化为精彩视频',
        ctaDescription: '立即体验 Hailuo AI，将您的创意转化为精彩视频',
        ctaButton: '在 WeryAI 上试用 Hailuo AI',

        ctaNote: '无需信用卡',
        ctaDisclaimer: '无需信用卡',


        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoUnsupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    pl: {

        // Page title and description
        pageTitle: 'Hailuo AI Video Generator - Innovative AI Video Creation Platform',
        pageDescription: 'Experience Hailuo AI video generator focused on intelligent video creation and content optimization. Uses advanced deep learning technology to generate high-quality and creative video content. Try it free on WeryAI platform.',
        pageKeywords: 'Hailuo AI, AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Hailuo 02 AI Video Generator (MiniMax)',
        generatorDescription: 'WeryAI jest teraz głęboko zintegrowane z modelem Hailuo AI, Hailuo AI, an innovative AI video generator. It\'s developed by <span class="highlight-bold">MiniMax, a Chinese tech company</span>, enabling users to <span class="highlight-bold">create video clips from text and images</span>. Hailuo also provides <span class="highlight-bold">realistic AI voice-overs and intelligent music library</span> that perfectly sync with your visual content. <span class="highlight-bold">Try Hailuo AI for free</span> now!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo AI Main Features',
        coreFeaturesSubtitle: 'Explore the core features of Hailuo AI video generator and embark on a revolutionary AI video creation journey',

        // Accurate instruction following
        accurateInstructionFollowingTitle: 'Accurate Instruction Following',
        accurateInstructionFollowingDescription: 'Understand and execute your creative prompts with unparalleled accuracy, ensuring the generated videos fully match your creative intent.',

        // Extreme physics and dynamic motion
        extremePhysicsMotionTitle: 'Extreme Physics and Dynamic Motion',
        extremePhysicsMotionDescription: 'Provides seamless and realistic motion even in the most demanding scenarios, showcasing excellent physics simulation and motion effects.',

        // Native 1080p output
        native1080pOutputTitle: 'Crystal Clear Native 1080p Output',
        native1080pOutputDescription: 'Experience professional-grade visual effects at native 1080p resolution, with every frame showcasing stunning clarity and detail.',

        // Cost-effective
        costEffectiveTitle: 'Unparalleled Cost-Effectiveness',
        costEffectiveDescription: 'Get world-class video quality without spending too much, providing you with the most cost-effective AI video generation solution.',

        // How to use section
        howToUseTitle: 'Jak używać',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Hailuo AI Model',
        step1Description: 'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo AI" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description: 'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description: 'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideosTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideoTitle: 'YouTube Videos About Hailuo 02 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 02 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',
        hailuo23Title: 'Hailuo 2.3 AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaDescription: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo AI on WeryAI',

        ctaNote: 'No credit card required',

        ctaDisclaimer: 'No credit card required',


        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
    es: {
        // Título y descripción de la página
        pageTitle: 'Generador de Video Hailuo AI - Plataforma Innovadora de Creación de Video con IA',
        pageDescription: 'Experimenta el generador de video Hailuo AI enfocado en la creación inteligente de videos y optimización de contenido. Utiliza tecnología avanzada de aprendizaje profundo para generar contenido de video de alta calidad y creativo. Pruébalo gratis en la plataforma WeryAI.',
        pageKeywords: 'Hailuo AI, generador de video IA, creación de video IA, video de inteligencia artificial, herramienta de generación de video, video IA gratis, WeryAI, producción de video',

        // Sección del generador
        generatorTitle: 'Generador de Video Hailuo 02 AI (MiniMax)',
        generatorDescription: 'WeryAI ahora integra profundamente el modelo Hailuo AI, Hailuo AI, un generador de video IA innovador. Desarrollado por <span class="highlight-bold">MiniMax, una empresa tecnológica china</span>, permite a los usuarios <span class="highlight-bold">crear clips de video a partir de texto e imágenes</span>. Hailuo también proporciona <span class="highlight-bold">voces en off de IA realistas y biblioteca de música inteligente</span> que se sincronizan perfectamente con tu contenido visual. ¡<span class="highlight-bold">Prueba Hailuo AI gratis</span> ahora!',
        
        // Pestañas
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',

        // Sección de características principales
        coreFeaturesTitle: 'Características Principales de Hailuo AI',
        coreFeaturesSubtitle: 'Explora las características principales del generador de video Hailuo AI y embárcate en un viaje revolucionario de creación de video con IA',

        // Seguimiento preciso de instrucciones
        accurateInstructionFollowingTitle: 'Seguimiento Preciso de Instrucciones',
        accurateInstructionFollowingDescription: 'Comprende y ejecuta tus indicaciones creativas con una precisión sin igual, asegurando que los videos generados coincidan completamente con tu intención creativa.',

        // Física extrema y movimiento dinámico
        extremePhysicsMotionTitle: 'Física Extrema y Movimiento Dinámico',
        extremePhysicsMotionDescription: 'Proporciona movimiento fluido y realista incluso en los escenarios más exigentes, mostrando una excelente simulación física y efectos de movimiento.',

        // Salida nativa 1080p
        native1080pOutputTitle: 'Salida Nativa 1080p Cristalina',
        native1080pOutputDescription: 'Experimenta efectos visuales de grado profesional a resolución nativa 1080p, con cada fotograma mostrando una claridad y detalle impresionantes.',

        // Rentabilidad
        costEffectiveTitle: 'Rentabilidad Incomparable',
        costEffectiveDescription: 'Obtén calidad de video de clase mundial sin gastar demasiado, proporcionándote la solución de generación de video con IA más rentable.',

        // Sección de cómo usar
        howToUseTitle: 'Cómo Usar',
        howToUseSubtitle: 'Tres simples pasos para comenzar',
        step1Title: 'Selecciona el Modelo Hailuo AI',
        step1Description: 'Ve a la página <span class="highlight-text">"Generación de Video con IA"</span>, luego haz clic en "Hailuo AI" en el menú desplegable de modelos.',
        step2Title: 'Ingresa Tu Contenido Creativo',
        step2Description: 'Describe lo que quieres generar, o sube imágenes para conversión, y elige tus estilos y efectos preferidos.',
        step3Title: 'Descarga Tu Video',
        step3Description: 'Haz clic en "Crear" para descargar o compartir el video optimizado generado.',

        // Sección de videos de YouTube
        youtubeTitle: 'Videos de YouTube sobre el Modelo de Video Hailuo 02',
        youtubeVideosTitle: 'Videos de YouTube sobre el Modelo de Video Hailuo 02',
        youtubeVideoTitle: 'Videos de YouTube sobre el Modelo de Video Hailuo 02',

        // Sección de publicaciones de X
        xPostsTitle: 'Publicaciones Populares de X sobre el Modelo de Video Hailuo 02',

        // Sección de explorar otros modelos
        exploreModelsTitle: 'Explorar Otros Modelos',
        sora2Title: 'Generador de Video OpenAI Sora-2 AI',
        veo31Title: 'Generador de Video Google Veo 3.1 AI',
        veo3Title: 'Generador de Video Google Veo 3 AI',
        veo3FastTitle: 'Generador de Video Google Veo 3 Fast AI',
        klingTitle: 'Generador de Video Kling AI',
        runwayTitle: 'Generador de Video Runway AI',
        wanTitle: 'Generador de Video Wan AI',

        // Sección de FAQ
        faqTitle: 'Preguntas Frecuentes',

        // Sección de CTA
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaSubtitle: 'Experimenta Hailuo AI ahora y transforma tu creatividad en videos increíbles',
        ctaDescription: 'Experimenta Hailuo AI ahora y transforma tu creatividad en videos increíbles',
        ctaButton: 'Prueba Hailuo AI en WeryAI',
        ctaNote: 'No se requiere tarjeta de crédito',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',

        // Relacionado con reproducción de video
        videoNotSupported: 'Su navegador no admite la reproducción de video',
        videoUnsupported: 'Su navegador no admite la reproducción de video',
        videoLoadingError: 'Error al cargar el video',
        videoLoadError: 'Error al cargar el video',
        videoReload: 'Recargar',
            hailuo23Title: 'Hailuo 2.3',
    },
    fr: {
        // Titre et description de la page
        pageTitle: 'Générateur Vidéo Hailuo AI - Plateforme Innovante de Création Vidéo IA',
        pageDescription: 'Découvrez le générateur vidéo Hailuo AI axé sur la création intelligente de vidéos et l\'optimisation de contenu. Utilise une technologie avancée d\'apprentissage profond pour générer un contenu vidéo de haute qualité et créatif. Essayez-le gratuitement sur la plateforme WeryAI.',
        pageKeywords: 'Hailuo AI, générateur vidéo IA, création vidéo IA, vidéo intelligence artificielle, outil de génération vidéo, vidéo IA gratuite, WeryAI, production vidéo',

        // Section générateur
        generatorTitle: 'Générateur Vidéo Hailuo 02 AI (MiniMax)',
        generatorDescription: 'WeryAI intègre désormais en profondeur le modèle Hailuo AI, Hailuo AI, un générateur vidéo IA innovant. Développé par <span class="highlight-bold">MiniMax, une entreprise technologique chinoise</span>, permettant aux utilisateurs de <span class="highlight-bold">créer des clips vidéo à partir de texte et d\'images</span>. Hailuo fournit également des <span class="highlight-bold">voix-off IA réalistes et une bibliothèque musicale intelligente</span> qui se synchronisent parfaitement avec votre contenu visuel. <span class="highlight-bold">Essayez Hailuo AI gratuitement</span> maintenant !',
        
        // Onglets
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',

        // Section des fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités Principales de Hailuo AI',
        coreFeaturesSubtitle: 'Explorez les fonctionnalités principales du générateur vidéo Hailuo AI et embarquez dans un voyage révolutionnaire de création vidéo IA',

        // Suivi précis des instructions
        accurateInstructionFollowingTitle: 'Suivi Précis des Instructions',
        accurateInstructionFollowingDescription: 'Comprend et exécute vos suggestions créatives avec une précision inégalée, garantissant que les vidéos générées correspondent parfaitement à votre intention créative.',

        // Physique extrême et mouvement dynamique
        extremePhysicsMotionTitle: 'Physique Extrême et Mouvement Dynamique',
        extremePhysicsMotionDescription: 'Fournit un mouvement fluide et réaliste même dans les scénarios les plus exigeants, démontrant une excellente simulation physique et des effets de mouvement.',

        // Sortie native 1080p
        native1080pOutputTitle: 'Sortie Native 1080p Cristalline',
        native1080pOutputDescription: 'Découvrez des effets visuels de qualité professionnelle en résolution native 1080p, avec chaque image présentant une clarté et des détails époustouflants.',

        // Rentabilité
        costEffectiveTitle: 'Rentabilité Inégalée',
        costEffectiveDescription: 'Obtenez une qualité vidéo de classe mondiale sans trop dépenser, vous offrant la solution de génération vidéo IA la plus rentable.',

        // Section comment utiliser
        howToUseTitle: 'Comment Utiliser',
        howToUseSubtitle: 'Trois étapes simples pour commencer',
        step1Title: 'Sélectionnez le Modèle Hailuo AI',
        step1Description: 'Accédez à la page <span class="highlight-text">« Génération Vidéo IA »</span>, puis cliquez sur « Hailuo AI » dans le menu déroulant des modèles.',
        step2Title: 'Entrez Votre Contenu Créatif',
        step2Description: 'Décrivez ce que vous voulez générer, ou téléchargez des images pour la conversion, et choisissez vos styles et effets préférés.',
        step3Title: 'Téléchargez Votre Vidéo',
        step3Description: 'Cliquez sur « Créer » pour télécharger ou partager la vidéo optimisée générée.',

        // Section vidéos YouTube
        youtubeTitle: 'Vidéos YouTube sur le Modèle Vidéo Hailuo 02',
        youtubeVideosTitle: 'Vidéos YouTube sur le Modèle Vidéo Hailuo 02',
        youtubeVideoTitle: 'Vidéos YouTube sur le Modèle Vidéo Hailuo 02',

        // Section publications X
        xPostsTitle: 'Publications X Populaires sur le Modèle Vidéo Hailuo 02',

        // Section explorer d\'autres modèles
        exploreModelsTitle: 'Explorer d\'Autres Modèles',
        sora2Title: 'Générateur Vidéo OpenAI Sora-2 AI',
        veo31Title: 'Générateur Vidéo Google Veo 3.1 AI',
        veo3Title: 'Générateur Vidéo Google Veo 3 AI',
        veo3FastTitle: 'Générateur Vidéo Google Veo 3 Fast AI',
        klingTitle: 'Générateur Vidéo Kling AI',
        runwayTitle: 'Générateur Vidéo Runway AI',
        wanTitle: 'Générateur Vidéo Wan AI',

        // Section FAQ
        faqTitle: 'Questions Fréquemment Posées',

        // Section CTA
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaSubtitle: 'Découvrez Hailuo AI maintenant et transformez votre créativité en vidéos incroyables',
        ctaDescription: 'Découvrez Hailuo AI maintenant et transformez votre créativité en vidéos incroyables',
        ctaButton: 'Essayez Hailuo AI sur WeryAI',
        ctaNote: 'Aucune carte de crédit requise',
        ctaDisclaimer: 'Aucune carte de crédit requise',

        // Lié à la lecture vidéo
        videoNotSupported: 'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoUnsupported: 'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoLoadingError: 'Échec du chargement de la vidéo',
        videoLoadError: 'Échec du chargement de la vidéo',
        videoReload: 'Recharger',
            hailuo23Title: 'Hailuo 2.3',
    },
    de: {
        // Seitentitel und Beschreibung
        pageTitle: 'Hailuo AI Video Generator - Innovative KI-Video-Erstellungsplattform',
        pageDescription: 'Erleben Sie den Hailuo AI Video Generator, der sich auf intelligente Videoerstellung und Content-Optimierung konzentriert. Verwendet fortschrittliche Deep-Learning-Technologie zur Generierung hochwertiger und kreativer Videoinhalte. Kostenlos auf der WeryAI-Plattform testen.',
        pageKeywords: 'Hailuo AI, KI-Videogenerator, KI-Videoerstellung, künstliche Intelligenz Video, Video-Generierungstool, kostenloses KI-Video, WeryAI, Videoproduktion',

        // Generator-Bereich
        generatorTitle: 'Hailuo 02 AI Video Generator (MiniMax)',
        generatorDescription: 'WeryAI integriert jetzt das Modell Hailuo AI tiefgreifend, Hailuo AI, ein innovativer KI-Videogenerator. Entwickelt von <span class="highlight-bold">MiniMax, einem chinesischen Technologieunternehmen</span>, ermöglicht es Benutzern, <span class="highlight-bold">Videoclips aus Text und Bildern zu erstellen</span>. Hailuo bietet auch <span class="highlight-bold">realistische KI-Voiceovers und eine intelligente Musikbibliothek</span>, die perfekt mit Ihrem visuellen Inhalt synchronisiert werden. <span class="highlight-bold">Probieren Sie Hailuo AI kostenlos aus</span>!',
        
        // Registerkarten
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        // Hauptfunktionen-Bereich
        coreFeaturesTitle: 'Hauptfunktionen von Hailuo AI',
        coreFeaturesSubtitle: 'Erkunden Sie die Kernfunktionen des Hailuo AI Video Generators und begeben Sie sich auf eine revolutionäre Reise der KI-Videoerstellung',

        // Präzise Anweisungsbefolgung
        accurateInstructionFollowingTitle: 'Präzise Anweisungsbefolgung',
        accurateInstructionFollowingDescription: 'Versteht und führt Ihre kreativen Eingabeaufforderungen mit beispielloser Genauigkeit aus und stellt sicher, dass die generierten Videos Ihrer kreativen Absicht vollständig entsprechen.',

        // Extreme Physik und dynamische Bewegung
        extremePhysicsMotionTitle: 'Extreme Physik und Dynamische Bewegung',
        extremePhysicsMotionDescription: 'Bietet nahtlose und realistische Bewegung selbst in den anspruchsvollsten Szenarien und zeigt hervorragende Physiksimulation und Bewegungseffekte.',

        // Native 1080p-Ausgabe
        native1080pOutputTitle: 'Kristallklare Native 1080p-Ausgabe',
        native1080pOutputDescription: 'Erleben Sie visuelle Effekte in professioneller Qualität mit nativer 1080p-Auflösung, wobei jeder Frame atemberaubende Klarheit und Details zeigt.',

        // Kosteneffizienz
        costEffectiveTitle: 'Unübertroffene Kosteneffizienz',
        costEffectiveDescription: 'Erhalten Sie weltklasse Videoqualität ohne zu viel auszugeben und bietet Ihnen die kosteneffizienteste KI-Video-Generierungslösung.',

        // Verwendungsabschnitt
        howToUseTitle: 'Verwendung',
        howToUseSubtitle: 'Drei einfache Schritte zum Einstieg',
        step1Title: 'Wählen Sie das Hailuo AI Modell',
        step1Description: 'Gehen Sie zur Seite <span class="highlight-text">„KI-Videogenerierung"</span> und klicken Sie dann im Modell-Dropdown-Menü auf „Hailuo AI".',
        step2Title: 'Geben Sie Ihren Kreativen Inhalt Ein',
        step2Description: 'Beschreiben Sie, was Sie generieren möchten, oder laden Sie Bilder zur Konvertierung hoch und wählen Sie Ihre bevorzugten Stile und Effekte.',
        step3Title: 'Laden Sie Ihr Video Herunter',
        step3Description: 'Klicken Sie auf „Erstellen", um das generierte optimierte Video herunterzuladen oder zu teilen.',

        // YouTube-Videos-Bereich
        youtubeTitle: 'YouTube-Videos über das Hailuo 02 Videomodell',
        youtubeVideosTitle: 'YouTube-Videos über das Hailuo 02 Videomodell',
        youtubeVideoTitle: 'YouTube-Videos über das Hailuo 02 Videomodell',

        // X-Posts-Bereich
        xPostsTitle: 'Beliebte X-Posts über das Hailuo 02 Videomodell',

        // Andere Modelle erkunden
        exploreModelsTitle: 'Andere Modelle Erkunden',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ-Bereich
        faqTitle: 'Häufig Gestellte Fragen',

        // CTA-Bereich
        ctaTitle: 'Bereit zum Erstellen?',
        ctaSubtitle: 'Erleben Sie Hailuo AI jetzt und verwandeln Sie Ihre Kreativität in erstaunliche Videos',
        ctaDescription: 'Erleben Sie Hailuo AI jetzt und verwandeln Sie Ihre Kreativität in erstaunliche Videos',
        ctaButton: 'Probieren Sie Hailuo AI auf WeryAI',
        ctaNote: 'Keine Kreditkarte erforderlich',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',

        // Videowiedergabe-bezogen
        videoNotSupported: 'Ihr Browser unterstützt die Videowiedergabe nicht',
        videoUnsupported: 'Ihr Browser unterstützt die Videowiedergabe nicht',
        videoLoadingError: 'Video konnte nicht geladen werden',
        videoLoadError: 'Video konnte nicht geladen werden',
        videoReload: 'Neu laden',
            hailuo23Title: 'Hailuo 2.3',
    },
    ru: {
        // Заголовок и описание страницы
        pageTitle: 'Генератор Видео Hailuo AI - Инновационная Платформа Создания Видео с ИИ',
        pageDescription: 'Испытайте генератор видео Hailuo AI, ориентированный на интеллектуальное создание видео и оптимизацию контента. Использует передовую технологию глубокого обучения для создания высококачественного и креативного видеоконтента. Попробуйте бесплатно на платформе WeryAI.',
        pageKeywords: 'Hailuo AI, генератор видео ИИ, создание видео ИИ, видео искусственного интеллекта, инструмент генерации видео, бесплатное видео ИИ, WeryAI, производство видео',

        // Раздел генератора
        generatorTitle: 'Генератор Видео Hailuo 02 AI (MiniMax)',
        generatorDescription: 'WeryAI теперь глубоко интегрировал модель Hailuo AI, Hailuo AI, инновационный генератор видео с ИИ. Разработан <span class="highlight-bold">MiniMax, китайской технологической компанией</span>, позволяет пользователям <span class="highlight-bold">создавать видеоклипы из текста и изображений</span>. Hailuo также предоставляет <span class="highlight-bold">реалистичные голосовые комментарии ИИ и интеллектуальную музыкальную библиотеку</span>, которые идеально синхронизируются с вашим визуальным контентом. <span class="highlight-bold">Попробуйте Hailuo AI бесплатно</span> прямо сейчас!',
        
        // Вкладки
        tabImageToVideo: 'Изображение в Видео',
        tabTextToVideo: 'Текст в Видео',

        // Раздел основных функций
        coreFeaturesTitle: 'Основные Функции Hailuo AI',
        coreFeaturesSubtitle: 'Изучите основные возможности генератора видео Hailuo AI и начните революционное путешествие по созданию видео с ИИ',

        // Точное выполнение инструкций
        accurateInstructionFollowingTitle: 'Точное Выполнение Инструкций',
        accurateInstructionFollowingDescription: 'Понимает и выполняет ваши творческие подсказки с беспрецедентной точностью, гарантируя, что сгенерированные видео полностью соответствуют вашему творческому замыслу.',

        // Экстремальная физика и динамическое движение
        extremePhysicsMotionTitle: 'Экстремальная Физика и Динамическое Движение',
        extremePhysicsMotionDescription: 'Обеспечивает плавное и реалистичное движение даже в самых требовательных сценариях, демонстрируя отличную физическую симуляцию и эффекты движения.',

        // Нативный вывод 1080p
        native1080pOutputTitle: 'Кристально Чистый Нативный Вывод 1080p',
        native1080pOutputDescription: 'Испытайте визуальные эффекты профессионального качества в нативном разрешении 1080p, где каждый кадр демонстрирует потрясающую четкость и детализацию.',

        // Экономическая эффективность
        costEffectiveTitle: 'Непревзойденная Экономическая Эффективность',
        costEffectiveDescription: 'Получите видео мирового класса без больших затрат, предоставляя вам самое экономически эффективное решение для генерации видео с ИИ.',

        // Раздел как использовать
        howToUseTitle: 'Как Использовать',
        howToUseSubtitle: 'Три простых шага для начала',
        step1Title: 'Выберите Модель Hailuo AI',
        step1Description: 'Перейдите на страницу <span class="highlight-text">«Генерация Видео с ИИ»</span>, затем нажмите «Hailuo AI» в выпадающем меню моделей.',
        step2Title: 'Введите Ваш Творческий Контент',
        step2Description: 'Опишите, что вы хотите создать, или загрузите изображения для преобразования, и выберите предпочитаемые стили и эффекты.',
        step3Title: 'Скачайте Ваше Видео',
        step3Description: 'Нажмите «Создать», чтобы скачать или поделиться сгенерированным оптимизированным видео.',

        // Раздел видео YouTube
        youtubeTitle: 'Видео YouTube о Видеомодели Hailuo 02',
        youtubeVideosTitle: 'Видео YouTube о Видеомодели Hailuo 02',
        youtubeVideoTitle: 'Видео YouTube о Видеомодели Hailuo 02',

        // Раздел публикаций X
        xPostsTitle: 'Популярные Публикации X о Видеомодели Hailuo 02',

        // Раздел изучения других моделей
        exploreModelsTitle: 'Изучить Другие Модели',
        sora2Title: 'Генератор Видео OpenAI Sora-2 AI',
        veo31Title: 'Генератор Видео Google Veo 3.1 AI',
        veo3Title: 'Генератор Видео Google Veo 3 AI',
        veo3FastTitle: 'Генератор Видео Google Veo 3 Fast AI',
        klingTitle: 'Генератор Видео Kling AI',
        runwayTitle: 'Генератор Видео Runway AI',
        wanTitle: 'Генератор Видео Wan AI',

        // Раздел FAQ
        faqTitle: 'Часто Задаваемые Вопросы',

        // Раздел CTA
        ctaTitle: 'Готовы Начать Создавать?',
        ctaSubtitle: 'Испытайте Hailuo AI сейчас и превратите свое творчество в удивительные видео',
        ctaDescription: 'Испытайте Hailuo AI сейчас и превратите свое творчество в удивительные видео',
        ctaButton: 'Попробуйте Hailuo AI на WeryAI',
        ctaNote: 'Кредитная карта не требуется',
        ctaDisclaimer: 'Кредитная карта не требуется',

        // Связанное с воспроизведением видео
        videoNotSupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoUnsupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoLoadingError: 'Не удалось загрузить видео',
        videoLoadError: 'Не удалось загрузить видео',
        videoReload: 'Перезагрузить',
            hailuo23Title: 'Hailuo 2.3',
    },
    pt: {
        // Título e descrição da página
        pageTitle: 'Gerador de Vídeo Hailuo AI - Plataforma Inovadora de Criação de Vídeo com IA',
        pageDescription: 'Experimente o gerador de vídeo Hailuo AI focado na criação inteligente de vídeos e otimização de conteúdo. Usa tecnologia avançada de aprendizado profundo para gerar conteúdo de vídeo de alta qualidade e criativo. Experimente gratuitamente na plataforma WeryAI.',
        pageKeywords: 'Hailuo AI, gerador de vídeo IA, criação de vídeo IA, vídeo de inteligência artificial, ferramenta de geração de vídeo, vídeo IA grátis, WeryAI, produção de vídeo',

        // Seção do gerador
        generatorTitle: 'Gerador de Vídeo Hailuo 02 AI (MiniMax)',
        generatorDescription: 'O WeryAI agora integra profundamente o modelo Hailuo AI, Hailuo AI, um gerador de vídeo com IA inovador. Desenvolvido pela <span class="highlight-bold">MiniMax, uma empresa de tecnologia chinesa</span>, permitindo aos usuários <span class="highlight-bold">criar clipes de vídeo a partir de texto e imagens</span>. Hailuo também fornece <span class="highlight-bold">narrações de IA realistas e biblioteca de música inteligente</span> que sincronizam perfeitamente com seu conteúdo visual. <span class="highlight-bold">Experimente o Hailuo AI gratuitamente</span> agora!',
        
        // Abas
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',

        // Seção de recursos principais
        coreFeaturesTitle: 'Principais Recursos do Hailuo AI',
        coreFeaturesSubtitle: 'Explore os recursos principais do gerador de vídeo Hailuo AI e embarque em uma jornada revolucionária de criação de vídeo com IA',

        // Seguimento preciso de instruções
        accurateInstructionFollowingTitle: 'Seguimento Preciso de Instruções',
        accurateInstructionFollowingDescription: 'Compreende e executa seus prompts criativos com precisão incomparável, garantindo que os vídeos gerados correspondam totalmente à sua intenção criativa.',

        // Física extrema e movimento dinâmico
        extremePhysicsMotionTitle: 'Física Extrema e Movimento Dinâmico',
        extremePhysicsMotionDescription: 'Fornece movimento suave e realista mesmo nos cenários mais exigentes, mostrando excelente simulação física e efeitos de movimento.',

        // Saída nativa 1080p
        native1080pOutputTitle: 'Saída Nativa 1080p Cristalina',
        native1080pOutputDescription: 'Experimente efeitos visuais de nível profissional em resolução nativa 1080p, com cada quadro exibindo clareza e detalhes impressionantes.',

        // Custo-benefício
        costEffectiveTitle: 'Custo-Benefício Incomparável',
        costEffectiveDescription: 'Obtenha qualidade de vídeo de classe mundial sem gastar demais, fornecendo a solução de geração de vídeo com IA mais econômica.',

        // Seção como usar
        howToUseTitle: 'Como Usar',
        howToUseSubtitle: 'Três passos simples para começar',
        step1Title: 'Selecione o Modelo Hailuo AI',
        step1Description: 'Vá para a página <span class="highlight-text">"Geração de Vídeo com IA"</span>, depois clique em "Hailuo AI" no menu suspenso de modelos.',
        step2Title: 'Insira Seu Conteúdo Criativo',
        step2Description: 'Descreva o que você deseja gerar ou carregue imagens para conversão e escolha seus estilos e efeitos preferidos.',
        step3Title: 'Baixe Seu Vídeo',
        step3Description: 'Clique em "Criar" para baixar ou compartilhar o vídeo otimizado gerado.',

        // Seção de vídeos do YouTube
        youtubeTitle: 'Vídeos do YouTube Sobre o Modelo de Vídeo Hailuo 02',
        youtubeVideosTitle: 'Vídeos do YouTube Sobre o Modelo de Vídeo Hailuo 02',
        youtubeVideoTitle: 'Vídeos do YouTube Sobre o Modelo de Vídeo Hailuo 02',

        // Seção de publicações X
        xPostsTitle: 'Publicações Populares do X Sobre o Modelo de Vídeo Hailuo 02',

        // Seção explorar outros modelos
        exploreModelsTitle: 'Explorar Outros Modelos',
        sora2Title: 'Gerador de Vídeo OpenAI Sora-2 AI',
        veo31Title: 'Gerador de Vídeo Google Veo 3.1 AI',
        veo3Title: 'Gerador de Vídeo Google Veo 3 AI',
        veo3FastTitle: 'Gerador de Vídeo Google Veo 3 Fast AI',
        klingTitle: 'Gerador de Vídeo Kling AI',
        runwayTitle: 'Gerador de Vídeo Runway AI',
        wanTitle: 'Gerador de Vídeo Wan AI',

        // Seção FAQ
        faqTitle: 'Perguntas Frequentes',

        // Seção CTA
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaSubtitle: 'Experimente o Hailuo AI agora e transforme sua criatividade em vídeos incríveis',
        ctaDescription: 'Experimente o Hailuo AI agora e transforme sua criatividade em vídeos incríveis',
        ctaButton: 'Experimente o Hailuo AI no WeryAI',
        ctaNote: 'Nenhum cartão de crédito necessário',
        ctaDisclaimer: 'Nenhum cartão de crédito necessário',

        // Relacionado à reprodução de vídeo
        videoNotSupported: 'Seu navegador não suporta reprodução de vídeo',
        videoUnsupported: 'Seu navegador não suporta reprodução de vídeo',
        videoLoadingError: 'Falha ao carregar o vídeo',
        videoLoadError: 'Falha ao carregar o vídeo',
        videoReload: 'Recarregar',
            hailuo23Title: 'Hailuo 2.3',
    },
    it: {
        // Titolo e descrizione della pagina
        pageTitle: 'Generatore Video Hailuo AI - Piattaforma Innovativa di Creazione Video con IA',
        pageDescription: 'Sperimenta il generatore video Hailuo AI focalizzato sulla creazione intelligente di video e ottimizzazione dei contenuti. Utilizza tecnologia avanzata di deep learning per generare contenuti video di alta qualità e creativi. Provalo gratuitamente sulla piattaforma WeryAI.',
        pageKeywords: 'Hailuo AI, generatore video IA, creazione video IA, video intelligenza artificiale, strumento di generazione video, video IA gratuito, WeryAI, produzione video',

        // Sezione generatore
        generatorTitle: 'Generatore Video Hailuo 02 AI (MiniMax)',
        generatorDescription: 'WeryAI integra ora in profondità il modello Hailuo AI, Hailuo AI, un generatore video con IA innovativo. Sviluppato da <span class="highlight-bold">MiniMax, un\'azienda tecnologica cinese</span>, consente agli utenti di <span class="highlight-bold">creare clip video da testo e immagini</span>. Hailuo fornisce anche <span class="highlight-bold">voci fuori campo IA realistiche e biblioteca musicale intelligente</span> che si sincronizzano perfettamente con i tuoi contenuti visivi. <span class="highlight-bold">Prova Hailuo AI gratuitamente</span> ora!',
        
        // Schede
        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',

        // Sezione funzionalità principali
        coreFeaturesTitle: 'Funzionalità Principali di Hailuo AI',
        coreFeaturesSubtitle: 'Esplora le funzionalità principali del generatore video Hailuo AI e intraprendi un viaggio rivoluzionario di creazione video con IA',

        // Seguimento preciso delle istruzioni
        accurateInstructionFollowingTitle: 'Seguimento Preciso delle Istruzioni',
        accurateInstructionFollowingDescription: 'Comprende ed esegue i tuoi prompt creativi con una precisione senza pari, garantendo che i video generati corrispondano completamente alla tua intenzione creativa.',

        // Fisica estrema e movimento dinamico
        extremePhysicsMotionTitle: 'Fisica Estrema e Movimento Dinamico',
        extremePhysicsMotionDescription: 'Fornisce un movimento fluido e realistico anche negli scenari più impegnativi, mostrando un\'eccellente simulazione fisica ed effetti di movimento.',

        // Output nativo 1080p
        native1080pOutputTitle: 'Output Nativo 1080p Cristallino',
        native1080pOutputDescription: 'Sperimenta effetti visivi di livello professionale a risoluzione nativa 1080p, con ogni fotogramma che mostra chiarezza e dettagli straordinari.',

        // Efficienza dei costi
        costEffectiveTitle: 'Efficienza dei Costi Incomparabile',
        costEffectiveDescription: 'Ottieni qualità video di livello mondiale senza spendere troppo, fornendoti la soluzione di generazione video con IA più conveniente.',

        // Sezione come usare
        howToUseTitle: 'Come Usare',
        howToUseSubtitle: 'Tre semplici passaggi per iniziare',
        step1Title: 'Seleziona il Modello Hailuo AI',
        step1Description: 'Vai alla pagina <span class="highlight-text">"Generazione Video con IA"</span>, quindi fai clic su "Hailuo AI" nel menu a discesa dei modelli.',
        step2Title: 'Inserisci il Tuo Contenuto Creativo',
        step2Description: 'Descrivi cosa vuoi generare o carica immagini per la conversione e scegli i tuoi stili ed effetti preferiti.',
        step3Title: 'Scarica il Tuo Video',
        step3Description: 'Fai clic su "Crea" per scaricare o condividere il video ottimizzato generato.',

        // Sezione video YouTube
        youtubeTitle: 'Video YouTube sul Modello Video Hailuo 02',
        youtubeVideosTitle: 'Video YouTube sul Modello Video Hailuo 02',
        youtubeVideoTitle: 'Video YouTube sul Modello Video Hailuo 02',

        // Sezione post X
        xPostsTitle: 'Post X Popolari sul Modello Video Hailuo 02',

        // Sezione esplora altri modelli
        exploreModelsTitle: 'Esplora Altri Modelli',
        sora2Title: 'Generatore Video OpenAI Sora-2 AI',
        veo31Title: 'Generatore Video Google Veo 3.1 AI',
        veo3Title: 'Generatore Video Google Veo 3 AI',
        veo3FastTitle: 'Generatore Video Google Veo 3 Fast AI',
        klingTitle: 'Generatore Video Kling AI',
        runwayTitle: 'Generatore Video Runway AI',
        wanTitle: 'Generatore Video Wan AI',

        // Sezione FAQ
        faqTitle: 'Domande Frequenti',

        // Sezione CTA
        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaSubtitle: 'Sperimenta Hailuo AI ora e trasforma la tua creatività in video straordinari',
        ctaDescription: 'Sperimenta Hailuo AI ora e trasforma la tua creatività in video straordinari',
        ctaButton: 'Prova Hailuo AI su WeryAI',
        ctaNote: 'Nessuna carta di credito richiesta',
        ctaDisclaimer: 'Nessuna carta di credito richiesta',

        // Relativo alla riproduzione video
        videoNotSupported: 'Il tuo browser non supporta la riproduzione video',
        videoUnsupported: 'Il tuo browser non supporta la riproduzione video',
        videoLoadingError: 'Caricamento video fallito',
        videoLoadError: 'Caricamento video fallito',
        videoReload: 'Ricarica',
            hailuo23Title: 'Hailuo 2.3',
    },
    ar: {
        // عنوان ووصف الصفحة
        pageTitle: 'مولد فيديو Hailuo AI - منصة إنشاء فيديو مبتكرة بالذكاء الاصطناعي',
        pageDescription: 'جرب مولد فيديو Hailuo AI المركز على الإنشاء الذكي للفيديو وتحسين المحتوى. يستخدم تقنية التعلم العميق المتقدمة لإنشاء محتوى فيديو عالي الجودة وإبداعي. جربه مجانًا على منصة WeryAI.',
        pageKeywords: 'Hailuo AI، مولد فيديو بالذكاء الاصطناعي، إنشاء فيديو بالذكاء الاصطناعي، فيديو الذكاء الاصطناعي، أداة إنشاء الفيديو، فيديو ذكاء اصطناعي مجاني، WeryAI، إنتاج الفيديو',

        // قسم المولد
        generatorTitle: 'مولد فيديو Hailuo 02 AI (MiniMax)',
        generatorDescription: 'يقوم WeryAI الآن بدمج نموذج Hailuo AI بعمق، Hailuo AI، مولد فيديو مبتكر بالذكاء الاصطناعي. تم تطويره بواسطة <span class="highlight-bold">MiniMax، شركة تقنية صينية</span>، مما يمكن المستخدمين من <span class="highlight-bold">إنشاء مقاطع فيديو من النصوص والصور</span>. يوفر Hailuo أيضًا <span class="highlight-bold">تعليقات صوتية واقعية بالذكاء الاصطناعي ومكتبة موسيقى ذكية</span> تتزامن تمامًا مع محتواك المرئي. <span class="highlight-bold">جرب Hailuo AI مجانًا</span> الآن!',
        
        // علامات التبويب
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',

        // قسم الميزات الأساسية
        coreFeaturesTitle: 'الميزات الرئيسية لـ Hailuo AI',
        coreFeaturesSubtitle: 'استكشف الميزات الأساسية لمولد فيديو Hailuo AI وابدأ رحلة ثورية في إنشاء الفيديو بالذكاء الاصطناعي',

        // متابعة دقيقة للتعليمات
        accurateInstructionFollowingTitle: 'متابعة دقيقة للتعليمات',
        accurateInstructionFollowingDescription: 'يفهم وينفذ مطالباتك الإبداعية بدقة لا مثيل لها، مما يضمن أن مقاطع الفيديو المُنشأة تتطابق تمامًا مع نيتك الإبداعية.',

        // الفيزياء الشديدة والحركة الديناميكية
        extremePhysicsMotionTitle: 'الفيزياء الشديدة والحركة الديناميكية',
        extremePhysicsMotionDescription: 'يوفر حركة سلسة وواقعية حتى في السيناريوهات الأكثر تطلبًا، مع عرض محاكاة فيزيائية وتأثيرات حركة ممتازة.',

        // إخراج أصلي 1080p
        native1080pOutputTitle: 'إخراج أصلي 1080p واضح كالكريستال',
        native1080pOutputDescription: 'جرب تأثيرات بصرية بمستوى احترافي بدقة أصلية 1080p، مع عرض كل إطار وضوحًا وتفاصيل مذهلة.',

        // فعالية التكلفة
        costEffectiveTitle: 'فعالية تكلفة لا مثيل لها',
        costEffectiveDescription: 'احصل على جودة فيديو عالمية المستوى دون إنفاق الكثير، مما يوفر لك حل إنشاء الفيديو بالذكاء الاصطناعي الأكثر فعالية من حيث التكلفة.',

        // قسم كيفية الاستخدام
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ثلاث خطوات بسيطة للبدء',
        step1Title: 'اختر نموذج Hailuo AI',
        step1Description: 'انتقل إلى صفحة <span class="highlight-text">"إنشاء الفيديو بالذكاء الاصطناعي"</span>، ثم انقر على "Hailuo AI" في قائمة النماذج المنسدلة.',
        step2Title: 'أدخل محتواك الإبداعي',
        step2Description: 'صف ما تريد إنشاءه، أو قم بتحميل الصور للتحويل، واختر الأنماط والتأثيرات المفضلة لديك.',
        step3Title: 'قم بتنزيل الفيديو الخاص بك',
        step3Description: 'انقر على "إنشاء" لتنزيل أو مشاركة الفيديو المُحسّن المُنشأ.',

        // قسم مقاطع فيديو YouTube
        youtubeTitle: 'مقاطع فيديو YouTube حول نموذج فيديو Hailuo 02',
        youtubeVideosTitle: 'مقاطع فيديو YouTube حول نموذج فيديو Hailuo 02',
        youtubeVideoTitle: 'مقاطع فيديو YouTube حول نموذج فيديو Hailuo 02',

        // قسم منشورات X
        xPostsTitle: 'منشورات X الشائعة حول نموذج فيديو Hailuo 02',

        // قسم استكشاف النماذج الأخرى
        exploreModelsTitle: 'استكشف نماذج أخرى',
        sora2Title: 'مولد فيديو OpenAI Sora-2 AI',
        veo31Title: 'مولد فيديو Google Veo 3.1 AI',
        veo3Title: 'مولد فيديو Google Veo 3 AI',
        veo3FastTitle: 'مولد فيديو Google Veo 3 Fast AI',
        klingTitle: 'مولد فيديو Kling AI',
        runwayTitle: 'مولد فيديو Runway AI',
        wanTitle: 'مولد فيديو Wan AI',

        // قسم الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',

        // قسم CTA
        ctaTitle: 'هل أنت مستعد لبدء الإنشاء؟',
        ctaSubtitle: 'جرب Hailuo AI الآن وحوّل إبداعك إلى مقاطع فيديو رائعة',
        ctaDescription: 'جرب Hailuo AI الآن وحوّل إبداعك إلى مقاطع فيديو رائعة',
        ctaButton: 'جرب Hailuo AI على WeryAI',
        ctaNote: 'لا حاجة لبطاقة ائتمان',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',

        // متعلق بتشغيل الفيديو
        videoNotSupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoUnsupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoLoadingError: 'فشل تحميل الفيديو',
        videoLoadError: 'فشل تحميل الفيديو',
        videoReload: 'إعادة تحميل',
                hailuo23Title: 'Hailuo 2.3',
    },
    th: { // Thai (copied from English)
        // Page title and description
        pageTitle: 'Hailuo AI Video Generator - Innovative AI Video Creation Platform',
        pageDescription: 'Experience Hailuo AI video generator focused on intelligent video creation and content optimization. Uses advanced deep learning technology to generate high-quality and creative video content. Try it free on WeryAI platform.',
        pageKeywords: 'Hailuo AI, AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Hailuo 02 AI Video Generator (MiniMax)',
        generatorDescription: 'ขณะนี้ WeryAI ได้ผสานรวมโมเดล Hailuo AI อย่างลึกซึ้งแล้ว ขณะนี้ WeryAI ได้ผสานรวมโมเดล Hailuo AI อย่างลึกซึ้งแล้ว Hailuo AI, an innovative AI video generator. It\'s developed by <span class="highlight-bold">MiniMax, a Chinese tech company</span>, enabling users to <span class="highlight-bold">create video clips from text and images</span>. Hailuo also provides <span class="highlight-bold">realistic AI voice-overs and intelligent music library</span> that perfectly sync with your visual content. <span class="highlight-bold">Try Hailuo AI for free</span> now!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo AI Main Features',
        coreFeaturesSubtitle: 'Explore the core features of Hailuo AI video generator and embark on a revolutionary AI video creation journey',

        // Accurate instruction following
        accurateInstructionFollowingTitle: 'Accurate Instruction Following',
        accurateInstructionFollowingDescription: 'Understand and execute your creative prompts with unparalleled accuracy, ensuring the generated videos fully match your creative intent.',

        // Extreme physics and dynamic motion
        extremePhysicsMotionTitle: 'Extreme Physics and Dynamic Motion',
        extremePhysicsMotionDescription: 'Provides seamless and realistic motion even in the most demanding scenarios, showcasing excellent physics simulation and motion effects.',

        // Native 1080p output
        native1080pOutputTitle: 'Crystal Clear Native 1080p Output',
        native1080pOutputDescription: 'Experience professional-grade visual effects at native 1080p resolution, with every frame showcasing stunning clarity and detail.',

        // Cost-effective
        costEffectiveTitle: 'Unparalleled Cost-Effectiveness',
        costEffectiveDescription: 'Get world-class video quality without spending too much, providing you with the most cost-effective AI video generation solution.',

        // How to use section
        howToUseTitle: 'วิธีใช้งาน',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Hailuo AI Model',
        step1Description: 'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo AI" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description: 'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description: 'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideosTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideoTitle: 'YouTube Videos About Hailuo 02 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 02 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',
        hailuo23Title: 'Hailuo 2.3 AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaDescription: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo AI on WeryAI',

        ctaNote: 'No credit card required',

        ctaDisclaimer: 'No credit card required',


        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    da: { // Danish (copied from English)
        // Page title and description
        pageTitle: 'Hailuo AI Video Generator - Innovative AI Video Creation Platform',
        pageDescription: 'Experience Hailuo AI video generator focused on intelligent video creation and content optimization. Uses advanced deep learning technology to generate high-quality and creative video content. Try it free on WeryAI platform.',
        pageKeywords: 'Hailuo AI, AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Hailuo 02 AI Video Generator (MiniMax)',
        generatorDescription: 'WeryAI har nu integreret modellen Hailuo AI i dybden, Hailuo AI, an innovative AI video generator. It\'s developed by <span class="highlight-bold">MiniMax, a Chinese tech company</span>, enabling users to <span class="highlight-bold">create video clips from text and images</span>. Hailuo also provides <span class="highlight-bold">realistic AI voice-overs and intelligent music library</span> that perfectly sync with your visual content. <span class="highlight-bold">Try Hailuo AI for free</span> now!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo AI Main Features',
        coreFeaturesSubtitle: 'Explore the core features of Hailuo AI video generator and embark on a revolutionary AI video creation journey',

        // Accurate instruction following
        accurateInstructionFollowingTitle: 'Accurate Instruction Following',
        accurateInstructionFollowingDescription: 'Understand and execute your creative prompts with unparalleled accuracy, ensuring the generated videos fully match your creative intent.',

        // Extreme physics and dynamic motion
        extremePhysicsMotionTitle: 'Extreme Physics and Dynamic Motion',
        extremePhysicsMotionDescription: 'Provides seamless and realistic motion even in the most demanding scenarios, showcasing excellent physics simulation and motion effects.',

        // Native 1080p output
        native1080pOutputTitle: 'Crystal Clear Native 1080p Output',
        native1080pOutputDescription: 'Experience professional-grade visual effects at native 1080p resolution, with every frame showcasing stunning clarity and detail.',

        // Cost-effective
        costEffectiveTitle: 'Unparalleled Cost-Effectiveness',
        costEffectiveDescription: 'Get world-class video quality without spending too much, providing you with the most cost-effective AI video generation solution.',

        // How to use section
        howToUseTitle: 'Sådan bruges det',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Hailuo AI Model',
        step1Description: 'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo AI" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description: 'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description: 'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideosTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideoTitle: 'YouTube Videos About Hailuo 02 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 02 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',
        hailuo23Title: 'Hailuo 2.3 AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaDescription: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo AI on WeryAI',

        ctaNote: 'No credit card required',

        ctaDisclaimer: 'No credit card required',


        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    no: { // Norwegian (copied from English)
        // Page title and description
        pageTitle: 'Hailuo AI Video Generator - Innovative AI Video Creation Platform',
        pageDescription: 'Experience Hailuo AI video generator focused on intelligent video creation and content optimization. Uses advanced deep learning technology to generate high-quality and creative video content. Try it free on WeryAI platform.',
        pageKeywords: 'Hailuo AI, AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Hailuo 02 AI Video Generator (MiniMax)',
        generatorDescription: 'WeryAI har nå integrert modellen Hailuo AI i dybden, Hailuo AI, an innovative AI video generator. It\'s developed by <span class="highlight-bold">MiniMax, a Chinese tech company</span>, enabling users to <span class="highlight-bold">create video clips from text and images</span>. Hailuo also provides <span class="highlight-bold">realistic AI voice-overs and intelligent music library</span> that perfectly sync with your visual content. <span class="highlight-bold">Try Hailuo AI for free</span> now!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo AI Main Features',
        coreFeaturesSubtitle: 'Explore the core features of Hailuo AI video generator and embark on a revolutionary AI video creation journey',

        // Accurate instruction following
        accurateInstructionFollowingTitle: 'Accurate Instruction Following',
        accurateInstructionFollowingDescription: 'Understand and execute your creative prompts with unparalleled accuracy, ensuring the generated videos fully match your creative intent.',

        // Extreme physics and dynamic motion
        extremePhysicsMotionTitle: 'Extreme Physics and Dynamic Motion',
        extremePhysicsMotionDescription: 'Provides seamless and realistic motion even in the most demanding scenarios, showcasing excellent physics simulation and motion effects.',

        // Native 1080p output
        native1080pOutputTitle: 'Crystal Clear Native 1080p Output',
        native1080pOutputDescription: 'Experience professional-grade visual effects at native 1080p resolution, with every frame showcasing stunning clarity and detail.',

        // Cost-effective
        costEffectiveTitle: 'Unparalleled Cost-Effectiveness',
        costEffectiveDescription: 'Get world-class video quality without spending too much, providing you with the most cost-effective AI video generation solution.',

        // How to use section
        howToUseTitle: 'Slik bruker du',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Hailuo AI Model',
        step1Description: 'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo AI" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description: 'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description: 'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideosTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideoTitle: 'YouTube Videos About Hailuo 02 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 02 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',
        hailuo23Title: 'Hailuo 2.3 AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaDescription: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo AI on WeryAI',

        ctaNote: 'No credit card required',

        ctaDisclaimer: 'No credit card required',


        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    nl: { // Dutch (copied from English)
        // Page title and description
        pageTitle: 'Hailuo AI Video Generator - Innovative AI Video Creation Platform',
        pageDescription: 'Experience Hailuo AI video generator focused on intelligent video creation and content optimization. Uses advanced deep learning technology to generate high-quality and creative video content. Try it free on WeryAI platform.',
        pageKeywords: 'Hailuo AI, AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Hailuo 02 AI Video Generator (MiniMax)',
        generatorDescription: 'WeryAI heeft het model Hailuo AI nu diep geïntegreerd, Hailuo AI, an innovative AI video generator. It\'s developed by <span class="highlight-bold">MiniMax, a Chinese tech company</span>, enabling users to <span class="highlight-bold">create video clips from text and images</span>. Hailuo also provides <span class="highlight-bold">realistic AI voice-overs and intelligent music library</span> that perfectly sync with your visual content. <span class="highlight-bold">Try Hailuo AI for free</span> now!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo AI Main Features',
        coreFeaturesSubtitle: 'Explore the core features of Hailuo AI video generator and embark on a revolutionary AI video creation journey',

        // Accurate instruction following
        accurateInstructionFollowingTitle: 'Accurate Instruction Following',
        accurateInstructionFollowingDescription: 'Understand and execute your creative prompts with unparalleled accuracy, ensuring the generated videos fully match your creative intent.',

        // Extreme physics and dynamic motion
        extremePhysicsMotionTitle: 'Extreme Physics and Dynamic Motion',
        extremePhysicsMotionDescription: 'Provides seamless and realistic motion even in the most demanding scenarios, showcasing excellent physics simulation and motion effects.',

        // Native 1080p output
        native1080pOutputTitle: 'Crystal Clear Native 1080p Output',
        native1080pOutputDescription: 'Experience professional-grade visual effects at native 1080p resolution, with every frame showcasing stunning clarity and detail.',

        // Cost-effective
        costEffectiveTitle: 'Unparalleled Cost-Effectiveness',
        costEffectiveDescription: 'Get world-class video quality without spending too much, providing you with the most cost-effective AI video generation solution.',

        // How to use section
        howToUseTitle: 'Zo gebruik je het',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Hailuo AI Model',
        step1Description: 'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo AI" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description: 'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description: 'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideosTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideoTitle: 'YouTube Videos About Hailuo 02 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 02 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',
        hailuo23Title: 'Hailuo 2.3 AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaDescription: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo AI on WeryAI',

        ctaNote: 'No credit card required',

        ctaDisclaimer: 'No credit card required',


        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    id: { // Indonesian (copied from English)
        // Page title and description
        pageTitle: 'Hailuo AI Video Generator - Innovative AI Video Creation Platform',
        pageDescription: 'Experience Hailuo AI video generator focused on intelligent video creation and content optimization. Uses advanced deep learning technology to generate high-quality and creative video content. Try it free on WeryAI platform.',
        pageKeywords: 'Hailuo AI, AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Hailuo 02 AI Video Generator (MiniMax)',
        generatorDescription: 'WeryAI kini telah mengintegrasikan model Hailuo AI secara mendalam, Hailuo AI, an innovative AI video generator. It\'s developed by <span class="highlight-bold">MiniMax, a Chinese tech company</span>, enabling users to <span class="highlight-bold">create video clips from text and images</span>. Hailuo also provides <span class="highlight-bold">realistic AI voice-overs and intelligent music library</span> that perfectly sync with your visual content. <span class="highlight-bold">Try Hailuo AI for free</span> now!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo AI Main Features',
        coreFeaturesSubtitle: 'Explore the core features of Hailuo AI video generator and embark on a revolutionary AI video creation journey',

        // Accurate instruction following
        accurateInstructionFollowingTitle: 'Accurate Instruction Following',
        accurateInstructionFollowingDescription: 'Understand and execute your creative prompts with unparalleled accuracy, ensuring the generated videos fully match your creative intent.',

        // Extreme physics and dynamic motion
        extremePhysicsMotionTitle: 'Extreme Physics and Dynamic Motion',
        extremePhysicsMotionDescription: 'Provides seamless and realistic motion even in the most demanding scenarios, showcasing excellent physics simulation and motion effects.',

        // Native 1080p output
        native1080pOutputTitle: 'Crystal Clear Native 1080p Output',
        native1080pOutputDescription: 'Experience professional-grade visual effects at native 1080p resolution, with every frame showcasing stunning clarity and detail.',

        // Cost-effective
        costEffectiveTitle: 'Unparalleled Cost-Effectiveness',
        costEffectiveDescription: 'Get world-class video quality without spending too much, providing you with the most cost-effective AI video generation solution.',

        // How to use section
        howToUseTitle: 'Cara Menggunakan',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Hailuo AI Model',
        step1Description: 'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo AI" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description: 'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description: 'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideosTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideoTitle: 'YouTube Videos About Hailuo 02 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 02 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',
        hailuo23Title: 'Hailuo 2.3 AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaDescription: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo AI on WeryAI',

        ctaNote: 'No credit card required',

        ctaDisclaimer: 'No credit card required',


        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    tr: { // Turkish (copied from English)
        // Page title and description
        pageTitle: 'Hailuo AI Video Generator - Innovative AI Video Creation Platform',
        pageDescription: 'Experience Hailuo AI video generator focused on intelligent video creation and content optimization. Uses advanced deep learning technology to generate high-quality and creative video content. Try it free on WeryAI platform.',
        pageKeywords: 'Hailuo AI, AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Hailuo 02 AI Video Generator (MiniMax)',
        generatorDescription: 'WeryAI artık Hailuo AI modelini derinlemesine entegre ediyor, Hailuo AI, an innovative AI video generator. It\'s developed by <span class="highlight-bold">MiniMax, a Chinese tech company</span>, enabling users to <span class="highlight-bold">create video clips from text and images</span>. Hailuo also provides <span class="highlight-bold">realistic AI voice-overs and intelligent music library</span> that perfectly sync with your visual content. <span class="highlight-bold">Try Hailuo AI for free</span> now!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo AI Main Features',
        coreFeaturesSubtitle: 'Explore the core features of Hailuo AI video generator and embark on a revolutionary AI video creation journey',

        // Accurate instruction following
        accurateInstructionFollowingTitle: 'Accurate Instruction Following',
        accurateInstructionFollowingDescription: 'Understand and execute your creative prompts with unparalleled accuracy, ensuring the generated videos fully match your creative intent.',

        // Extreme physics and dynamic motion
        extremePhysicsMotionTitle: 'Extreme Physics and Dynamic Motion',
        extremePhysicsMotionDescription: 'Provides seamless and realistic motion even in the most demanding scenarios, showcasing excellent physics simulation and motion effects.',

        // Native 1080p output
        native1080pOutputTitle: 'Crystal Clear Native 1080p Output',
        native1080pOutputDescription: 'Experience professional-grade visual effects at native 1080p resolution, with every frame showcasing stunning clarity and detail.',

        // Cost-effective
        costEffectiveTitle: 'Unparalleled Cost-Effectiveness',
        costEffectiveDescription: 'Get world-class video quality without spending too much, providing you with the most cost-effective AI video generation solution.',

        // How to use section
        howToUseTitle: 'Nasıl Kullanılır',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Hailuo AI Model',
        step1Description: 'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo AI" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description: 'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description: 'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideosTitle: 'YouTube Videos About Hailuo 02 Video Model',
        youtubeVideoTitle: 'YouTube Videos About Hailuo 02 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 02 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',
        veo3FastTitle: 'Google Veo 3 Fast AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        wanTitle: 'Wan AI Video Generator',
        hailuo23Title: 'Hailuo 2.3 AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaDescription: 'Experience Hailuo AI now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo AI on WeryAI',

        ctaNote: 'No credit card required',

        ctaDisclaimer: 'No credit card required',


        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
}
